import { DataType } from '@inpart-io/padme-iap';

export const LayoutSettingsTabKeys = {
    MANDATORY_KEY: 'MANDATORY',
    VIEWS_KEY: 'VIEWS'
} as const;

export const layoutDataTypes = [DataType.Lead, DataType.LeadProfile, DataType.AgreementDetail];
export const specificLeadCaseDataTypes = [DataType.Lead, DataType.LeadProfile];

export const DefaultLeadLayoutValue = 'null';

export const layoutDataTypeLabels = {
    RIGHT_COLUMN: 1,
    LEFT_COLUMN: 2
} as const;

export const layoutDataTypeCriteriaAttributes: Record<string, string> = {
    [DataType.Lead]: 'dealType',
    [DataType.LeadProfile]: 'dealType',
    [DataType.AgreementDetail]: 'category'
};
